module.exports = __webpack_public_path__ + "img/loginbackground.1dff0048.png";